<template>
  <div class="opc-zone-bundle__main-add-content">
    <config-calling-row
      v-on="$listeners"
      :min-hosts="minHosts"
      :decrease-tips="decreaseTips"
      :billing-cycle="planBillInfo.billing_cycle"
      :plan-list="getPlanList(PBX_REGIONS.US_AND_CANADA)" />
    <appeal-cycle
      :cycle="i18n_cycle(planBillInfo.baseCycle)"
      :payment="planBillInfo.payasyougo"
      class='appeal-cycle' />
  </div>
</template>

<script type="text/jsx">
import ConfigCallingRow from '@/plans/ZONE_PRO_PLUS/component/config-calling-row';
import { mapGetters } from 'vuex';
import { computedCallingPlans } from '@/common/service/computers/plans/pbx';
import { getZPCallingFeesText } from '@/plans/ZOOM_PHONE/helper/utils';
import { BILLING_CYCLE, planTypes } from '@/common/constants';
import { i18n_cycle } from '@/utils/i18n-shortcuts';
import PbxMixin from '@/plans/ZONE_PRO_PLUS/mixin/pbx-mixin';
import { plansof } from '@/utils/chain';
import _ from 'lodash';
import { PBX_REGIONS } from '@/plans/ZOOM_PHONE/helper/constants';
import AppealCycle from '@/plans/ZOOM_PHONE/component/appeal-cycle';
import { getPbxCurrentBillingCycle } from '@/plans/ZOOM_PHONE/helper/pbx-billing-cycle';

export default {
  components: { AppealCycle, ConfigCallingRow },
  mixins: [PbxMixin],
  props: {
    minHosts: {
      type: Number,
      default: 1,
    },
    decreaseTips: String
  },
  data() {
    return {
      PBX_REGIONS: Object.freeze(PBX_REGIONS),
    };
  },
  computed: {
    ...mapGetters(['boughtPlans', 'planMapFlat', 'getSelectedPlans']),
    planBillInfo() {
      const callingPlan = computedCallingPlans(this.boughtPlans)?.[0] ??
        (computedCallingPlans(this.getSelectedPlans)?.[0] ?? {});
      const pbxBasePlan = this.boughtPbxBasePlan;
      const payasyougo = getZPCallingFeesText(pbxBasePlan).title;
      const billingCycle = getPbxCurrentBillingCycle(pbxBasePlan, callingPlan);

      const baseCycle = pbxBasePlan.billing_cycle === BILLING_CYCLE.PAY_AS_YOU_GO ? BILLING_CYCLE.MONTHLY : pbxBasePlan.billing_cycle;
      return {
        baseCycle,
        billing_cycle: billingCycle,
        payasyougo,
      };
    },
    planList() {
      return plansof(this.planMapFlat).type(planTypes.ZONE_PRO_PLUS).get();
    },
  },
  methods: {
    i18n_cycle,
    getPlanList(region) {
      return _.filter(this.planList, (p) => p.region === region);
    },
  },
};
</script>

<style lang="scss">
.opc-zone-bundle {
  &__main-add-content {
    .appeal-cycle {
      margin-top: 24px;
    }
  }
}
</style>
